import { __awaiter } from "tslib";
import { windowWidth, getElementBoundingClientRect } from '../utils';
export function px2rem(px) {
    return (px * 750) / windowWidth;
}
export function getComponentRect(id, callback, retry) {
    return __awaiter(this, void 0, void 0, function* () {
        if (callback) {
            const rect = yield getElementBoundingClientRect(id);
            callback({
                result: true,
                size: {
                    x: px2rem(rect.x),
                    y: px2rem(rect.y),
                    width: px2rem(rect.width),
                    height: px2rem(rect.height),
                    top: px2rem(rect.top),
                    bottom: px2rem(rect.bottom),
                    left: px2rem(rect.left),
                    right: px2rem(rect.right),
                },
            });
        }
    });
}
